<app-auth-base-layout [title]="step() === 'email' ? 'Recuperar contraseña' : step() === 'code' ? 'Ingresa el código' : 'Nueva contraseña'">

    <!-- Paso 1: Email -->
    <ng-container auth-content *ngIf="step() === 'email'">
        <p class="text-body-secondary mb-4">
            Ingresa el correo de tu cuenta de administrador. Recibirás un código de 6 dígitos para restablecer tu contraseña.
        </p>
        <form [formGroup]="emailForm" (ngSubmit)="submitEmail()">
            <div class="mb-3">
                <label cLabel for="email">Correo electrónico</label>
                <input
                    cFormControl
                    type="email"
                    id="email"
                    formControlName="email"
                    placeholder="usuario@ejemplo.com"
                    [class.is-invalid]="!!getEmailError('email')"
                />
                @if (getEmailError('email')) {
                    <p class="text-danger small mt-1">{{ getEmailError('email') }}</p>
                }
            </div>
            <div class="d-grid">
                <button cButton color="primary" type="submit" [disabled]="isLoading()">
                    @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Enviando...
                    } @else {
                        Enviar código
                    }
                </button>
            </div>
        </form>
    </ng-container>

    <!-- Paso 2: Código -->
    <ng-container auth-content *ngIf="step() === 'code'">
        <p class="text-body-secondary mb-4">
            Revisa tu correo electrónico e ingresa el código de 6 dígitos que te enviamos.
        </p>
        <form [formGroup]="codeForm" (ngSubmit)="submitCode()">
            <div class="mb-3">
                <label cLabel for="code">Código de verificación</label>
                <input
                    cFormControl
                    type="text"
                    id="code"
                    formControlName="code"
                    placeholder="123456"
                    maxlength="6"
                    [class.is-invalid]="!!getCodeError()"
                />
                @if (getCodeError()) {
                    <p class="text-danger small mt-1">{{ getCodeError() }}</p>
                }
            </div>
            <div class="d-grid">
                <button cButton color="primary" type="submit" [disabled]="isLoading()">
                    @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Verificando...
                    } @else {
                        Verificar código
                    }
                </button>
            </div>
        </form>
    </ng-container>

    <!-- Paso 3: Nueva contraseña -->
    <ng-container auth-content *ngIf="step() === 'password'">
        <p class="text-body-secondary mb-4">
            Ingresa y confirma tu nueva contraseña. Debe tener al menos 8 caracteres.
        </p>
        <form [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
            <div class="mb-3">
                <label cLabel for="new_password">Nueva contraseña</label>
                <input
                    cFormControl
                    type="password"
                    id="new_password"
                    formControlName="new_password"
                    placeholder="••••••••"
                    [class.is-invalid]="!!getPasswordError('new_password')"
                />
                @if (getPasswordError('new_password')) {
                    <p class="text-danger small mt-1">{{ getPasswordError('new_password') }}</p>
                }
            </div>
            <div class="mb-3">
                <label cLabel for="confirm_password">Confirmar contraseña</label>
                <input
                    cFormControl
                    type="password"
                    id="confirm_password"
                    formControlName="confirm_password"
                    placeholder="••••••••"
                    [class.is-invalid]="!!getPasswordError('confirm_password')"
                />
                @if (getPasswordError('confirm_password')) {
                    <p class="text-danger small mt-1">{{ getPasswordError('confirm_password') }}</p>
                }
            </div>
            <div class="d-grid">
                <button cButton color="primary" type="submit" [disabled]="isLoading()">
                    @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Actualizando...
                    } @else {
                        Actualizar contraseña
                    }
                </button>
            </div>
        </form>
    </ng-container>

    <ng-container auth-footer>
        <a routerLink="/login" class="text-white text-decoration-underline">
            Volver al inicio de sesión
        </a>
    </ng-container>

</app-auth-base-layout>
